import { createContext, Dispatch, SetStateAction } from 'react';
import { AxiosResponse } from 'axios';

import { CardForm } from '@vyce/core/src/types';
import { CreateTeamData, GetStaffResponse, ListStaffRequest } from '@vyce/core/src/api/types';

interface PaginationOptions {
  page: number;
  pageSize: number;
  pageCount: number;
  rowCount: number;
  setPage: Dispatch<SetStateAction<number>>;
}

interface Context {
  isLoading: boolean;
  isOpenSubscriptionDialog?: boolean;
  isOpenTeamDialog: boolean;
  needToReset: boolean;
  substring: string;
  paginationOptions: PaginationOptions;
  first_name?: string;
  isOpenNonSubscribedDialog?: boolean;
  wasSubscribed?: boolean;
  // functions
  openTeamDialog: Function;
  setSubscriptionDialogOpen?: Function;
  setOpenTeamDialog: Function;
  handleSearchChange: (event: any) => void;
  sort: (option: string) => void;
  subscribe?: (data: CardForm) => Promise<void>;
  finishCreateTeam: (data: CreateTeamData) => void;
  createTeam: ({
    formData,
    needToRedirect,
  }: {
    formData: CreateTeamData | null;
    needToRedirect?: boolean | undefined;
  }) => Promise<void>;
  handleCloseNonSubscribedDialog?: () => void;
  goToTeamChat?: (teamId: string, teamName: string) => Promise<void>;
  selectedCompanyId?: string;
  getStaffRequest?: (
    companyId: string,
    payload: ListStaffRequest
  ) => Promise<AxiosResponse<GetStaffResponse>>;
}

export const TeamListModuleContext = createContext({} as Context);

export const TeamListModuleProvider = TeamListModuleContext.Provider;
